import ScreenSizeMixin from '@/mixins/ScreenSizeMixin'

export default {
  mixins: [ScreenSizeMixin],

  data() {
    return {
      infoWindow: null,
    }
  },

  computed: {
    infoWindowHeight() {
      return this.availableHeight > 600 ? '500px' : '200px'
    },
  },

  methods: {
    initInfoWindow() {
      this.infoWindow = new this.google.maps.InfoWindow()
    },

    /**
     * Open the marker/cluster info window
     * @param {string} contents to display in the info window
     * @param {object} marker to display in the info window
     * @param {object} position to anchor the info window
     */
    openInfoWindow(contents, marker, position) {
      this.infoWindow.setContent(contents)
      this.infoWindow.setPosition(position)
      if (marker) {
        this.infoWindow.open(this.map, marker)
      } else {
        this.infoWindow.open(this.map)
      }
    },
  },
}
